// CalendarScreen.styles.js

const CalendarScreenStyles = {
  container: {
    padding: "2rem",
    maxWidth: "1200px",
    margin: "auto",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  calendar: {
    height: "500px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    padding: "2rem",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    minWidth: "400px",
  },
  textField: {
    marginTop: "1rem",
  },
  submitButton: {
    marginTop: "1.5rem",
    width: "100%",
    padding: "0.75rem",
    fontWeight: "bold",
  },
};

export default CalendarScreenStyles;


// const CalendarScreenStyles = {
//     container: {
//       padding: '2rem',
//       maxWidth: '1200px',
//       margin: 'auto',
//     },
//     title: {
//       fontWeight: 'bold',
//       marginBottom: '1.5rem',
//       textAlign: 'center',
//     },
//     calendar: {
//       height: '500px',
//       backgroundColor: '#ffffff',
//       borderRadius: '8px',
//       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
//     },
//     modal: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//     modalContent: {
//       padding: '2rem',
//       backgroundColor: '#ffffff',
//       borderRadius: '8px',
//       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
//       minWidth: '400px',
//     },
//     textField: {
//       marginTop: '1rem',
//     },
//     submitButton: {
//       marginTop: '1.5rem',
//       width: '100%',
//       padding: '0.75rem',
//       fontWeight: 'bold',
//     },
//   };
  
//   export default CalendarScreenStyles;
  